/**
 * Centralized API Configuration
 * All API URLs and configuration should be managed here
 */

// Get API URL from environment variable
// In production, REACT_APP_API_URL must be set
const getApiUrl = () => {
    // Hardcoded API URL per request
        return 'https://servermain.sisrevolution.com';
};

export const API_CONFIG = {
    BASE_URL: getApiUrl(),
    TIMEOUT: 180000, // 180 seconds (3 minutes) - increased for better reliability
    UPLOAD_TIMEOUT: 300000, // 300 seconds (5 minutes) for file uploads
    
    // API Endpoints
    ENDPOINTS: {
        AUTH: {
            LOGIN: '/api/schools/login',
            REFRESH: '/api/schools/refresh',
            ME: '/api/schools/me',
            LOGOUT: '/api/schools/logout'
        },
        SCHOOLS: {
            GET_DATA: '/api/schools/getschooldata/',
            UPDATE: '/api/schools/update/'
        },
        STUDENTS: {
            GET_DATA: '/api/students/getstudentdata/',
            REGISTER: '/api/students/registerstudent',
            PAY_FEES: '/api/students/payfees/',
            DISCOUNT: '/api/students/discount/',
            ADD_DEBT: '/api/students/adddebt/',
            UPDATE_IMAGE: '/api/students/updateimage/',
            PAY_CHARGES: '/api/students/paycharges/',
            DAILY_CHARGES: '/api/students/dailycharges/',
            WEEKLY_CHARGES: '/api/students/weeklycharges/',
            MONTHLY_CHARGES: '/api/students/monthlycharges/',
            DEBTORS_SMS: '/api/students/debtorssms/',
            BULK_BILL: '/api/students/bulkbill/'
        },
        SCHOOL: {
            UPDATE_SCHOOL_DATA: '/api/school/updateschooldata/',
            EDIT_SCHOOL: '/api/school/editschool/',
            ADD_SCHOOL: '/api/school/addschool/',
            DELETE_SCHOOL: '/api/school/deleteschool/'
        },
        CLASS: {
            GET_DATA: '/api/class/getclassdata1/',
            CLASS_FEES: '/api/class/classfees/'
        },
        CLASS: {
            GET_DATA: '/api/class/getclassdata1/'
        },
        TEACHERS: {
            GET_DATA: '/api/teachers/getteacherdata/'
        },
        PARENTS: {
            GET_DATA: '/api/parents/getparentdata/'
        }
    }
};

/**
 * Build full API URL
 */
export const buildApiUrl = (endpoint) => {
    // Remove leading slash if present
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
    return `${API_CONFIG.BASE_URL}${cleanEndpoint}`;
};

/**
 * Validate API URL format
 */
export const validateApiUrl = (url) => {
    try {
        const urlObj = new URL(url);
        return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';
    } catch {
        return false;
    }
};

// Validate on module load
if (!validateApiUrl(API_CONFIG.BASE_URL)) {
    console.warn(`⚠️ Invalid API URL format: ${API_CONFIG.BASE_URL}`);
}

export default API_CONFIG;

